import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchVersion } from '@repository/versionRepository';
import { FetchVersionError, FetchVersionResponse } from '@models/version/FetchVersion';
import { secondsToMillis } from '@utils/millis';

const useFetchVersion = () => {
    return useQuery<FetchVersionResponse, FetchVersionError>({
        queryKey: [QueryKey.Version],
        queryFn: ({ signal }) => fetchVersion({ signal }),
        staleTime: secondsToMillis(30),
    });
};

export default useFetchVersion;
